import {useEffect, useState} from 'react';
import {
    StyledModal,
    StyledModalBody,
    StyledModalClose,
    StyledModalDialog,
    StyledModalHeader,
} from '../../helpers/base-modal';
import {DoubleRow, DoubleRowItem, Field, Input, Label} from '../../helpers/base-field';
import {Button, ButtonColor, ButtonSize} from '../button/button';

const SaveOrderModal = ({isOpen, taskNumber, onClose}) => {
    const [nextModalStep, setNextModalStep] = useState(1);
    const [inputValue, setInputValue] = useState('');
    const [authLink, setAuthLink] = useState('');
    const [regLink, setRegLink] = useState('');

    const authPath = '/auth/?backurl=';
    const regPath = '/auth/registration/?backurl=';
    const currentPath = window.location.pathname;

    const submitHandler = () => {
        let dataJson = {
            ['order-task-id']: encodeURI(taskNumber),
            ['order-name']: encodeURI(inputValue),
        };

        dataJson = JSON.stringify(dataJson);
        const orderParams = btoa(unescape(encodeURIComponent(dataJson)));

        const authorizeUrl = authPath + currentPath + '?save-order=' + orderParams;
        const registerUrl = regPath + currentPath + '?save-order=' + orderParams;

        setAuthLink(authorizeUrl);
        setRegLink(registerUrl);
    };

    const closeHandler = () => {
        onClose();
    };

    useEffect(() => {
        const keydownHandler = ({key}) => {
            switch (key) {
                case 'Escape':
                    closeHandler();
                    break;
                default:
            }
        };

        document.addEventListener('keydown', keydownHandler);

        return () => document.removeEventListener('keydown', keydownHandler);
    });

    return !isOpen ? null : (
        <StyledModal onMouseDown={closeHandler}>
            <StyledModalDialog isOpen={isOpen} onMouseDown={(event) => event.stopPropagation()}>
                <StyledModalHeader>
                    Сохранить заказ для отслеживания?
                    <StyledModalClose title={'Закрыть'} onClick={closeHandler}>
                        <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="m1 1 12 12m0-12L1 13" stroke="currentColor" strokeWidth="1.5" />
                        </svg>
                    </StyledModalClose>
                </StyledModalHeader>

                {nextModalStep === 1 && (
                    <StyledModalBody>
                        <DoubleRow>
                            <DoubleRowItem>
                                <Button
                                    size={ButtonSize.LARGE}
                                    color={ButtonColor.DARK_BLUE}
                                    onClick={() => setNextModalStep(2)}
                                >
                                    Да
                                </Button>
                            </DoubleRowItem>
                            <DoubleRowItem>
                                <Button
                                    title={'Отменить действие'}
                                    size={ButtonSize.LARGE}
                                    color={ButtonColor.BORDER_BLUE}
                                    onClick={onClose}
                                >
                                    Нет
                                </Button>
                            </DoubleRowItem>
                        </DoubleRow>
                    </StyledModalBody>
                )}

                {nextModalStep === 2 && (
                    <StyledModalBody as={'form'} name="save-order">
                        <Field>
                            <Label htmlFor={'order-name'}>Название заказа (укажите по желанию)</Label>
                            <Input
                                id={'order-name'}
                                type={'text'}
                                name={'order-name'}
                                onChange={(event) => setInputValue(event.target.value)}
                            />
                        </Field>
                        <DoubleRow>
                            <DoubleRowItem>
                                <Button
                                    size={ButtonSize.LARGE}
                                    color={ButtonColor.DARK_BLUE}
                                    onClick={() => {
                                        setNextModalStep(3);
                                        submitHandler();
                                    }}
                                >
                                    Сохранить
                                </Button>
                            </DoubleRowItem>
                            <DoubleRowItem>
                                <Button
                                    title={'Отменить действие'}
                                    size={ButtonSize.LARGE}
                                    color={ButtonColor.BORDER_BLUE}
                                    onClick={onClose}
                                >
                                    Отмена
                                </Button>
                            </DoubleRowItem>
                        </DoubleRow>
                    </StyledModalBody>
                )}

                {nextModalStep === 3 && (
                    <StyledModalBody>
                        <DoubleRow>
                            <DoubleRowItem>
                                <a href={authLink}>
                                    <Button size={ButtonSize.LARGE} color={ButtonColor.DARK_BLUE}>
                                        Войти
                                    </Button>
                                </a>
                            </DoubleRowItem>
                            <DoubleRowItem>
                                <a href={regLink}>
                                    <Button size={ButtonSize.LARGE} color={ButtonColor.BORDER_BLUE}>
                                        Регистрация
                                    </Button>
                                </a>
                            </DoubleRowItem>
                        </DoubleRow>
                    </StyledModalBody>
                )}
            </StyledModalDialog>
        </StyledModal>
    );
};

export {SaveOrderModal};
